/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable arrow-body-style */
import { getSelectorConfig } from '@/pages/benchmark/services/benchmark';
import {  useEffect, useMemo, useState } from 'react';
import { TFilterSelectorProps, TInputListItem, TSelectorDataProps } from './_type';
import { useFilterList } from './useFilterList';
import { getCountryFlag } from '@home/_config/countries';
import { useParams } from 'umi';
// 多选级联筛选器下拉过滤
const filterCascadeOptions = (data: any [], filterData: string[]) => {
  return data.map(item => ({
    ...item,
    list: item.list.filter((listItem: { code: string; }) => filterData.includes(listItem.code))
  })).filter(item => item.list.length > 0);
};

export const useFilterSelector = (props: TFilterSelectorProps) => {
  const { api = '/api/v2/dashboard/studio/game/kol/selector', selectorList: propsSelector,  otherParams, ...resetProps} = props;
  const { studioId, gameCode } = useParams() || {} as any;
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<boolean>(false);
  const [selectorData, setSelectorData] = useState<TSelectorDataProps>(null);
  const { filterConfigList } = useFilterList();

  useEffect(() => {
    setError(false);
    setLoading(true);
    getSelectorConfig({
      api,
      studio_code: studioId,
      game_code: gameCode,
      selector_list: propsSelector,
      ...(otherParams || {})
    }).then((data) => {
      setSelectorData(data);
    }).catch((e) => {
      setError(true);
      console.log('useFilterSelector error', e);
    }).finally(() => {
      setLoading(false);
    });
  }, [api, studioId, gameCode, propsSelector, otherParams]);

  const { selectorList} = useMemo(() => {
    if (!selectorData) return {};

    // 构建最终的对象
    const result: { [key: string]: any; } = {};
    const keys = Object.keys(selectorData);
    for (const key of keys) {
      const slectorItem = selectorData?.[key];
      
      if(key === 'region_country') {
        result[key] = slectorItem?.map((item: any)=>{
          return {
            ...(item || {}),
            // 后端反馈中英文都为label
            text: item?.label,
            textCN: item?.label,
            code: item?.value,
            children: item?.children?.map((child: any)=>{
              return {
                ...child,
                // 后端反馈中英文都为label
                text: child?.label,
                textCN: child?.label,
                icon: getCountryFlag(child?.value),
                code: child?.value,
              };
            }) || []
          };
        });
      } else {
        result[key] = slectorItem?.map((item: any)=>{
          return {
            ...item,
            // 后端反馈中英文都为label
            name_en: item?.label,
            name_ch: item?.label,
            // value: item?.value,
            code: item?.value,
          };
        });
      }
      
    }
    return {
      selectorList: result,
    };
  }, [selectorData]);

  // 筛选器配置和下拉等相关信息
  const inputList: TInputListItem[] = useMemo(() => {
    const sortKeyArr =Object.keys(filterConfigList || {});
    // 和后端约定过前端filterConfigList的key和selector的key是相同的
    const result = sortKeyArr?.map((item: string) => {
      const selectorItem = selectorList?.[item];
      const key = item;
      const filterConfig = filterConfigList?.[key];
      // eslint-disable-next-line prefer-const
      let {view_type: viewType, nameCN, nameEN, default: defaultValue, name, visible  } = filterConfig || {};

      return {
        ...(filterConfig || {}),
        key,
        type: key,
        dataKey: item,
        name_cn: nameCN || key,
        name_en: nameEN || key,
        name: name || key,
        default: defaultValue,
        view_type: viewType,
        visible,
        options: selectorItem,

      };
    });
    return result;
  }, [filterConfigList, selectorList]);

  return {
    loading,
    error,
    inputList,
    selectorList,
  };
};
